import { ConsoleLogger } from '@mimir/common/util/logging';
import type { BrowserAACLactencyBehavior } from './detectBrowserAacLatencyBehavior';
import { detectBrowserAacLatencyBehavior } from './detectBrowserAacLatencyBehavior';


export function initializeBrowserBehavior() {
  detectBrowserAacLatencyBehavior(new ConsoleLogger())
    .then((result) => {
      browserAacLatencyBehavior = result;
    })
    // This promise will never reject
    .catch(() => { });

}


export interface BrowserBehavior {
  hidesFirstFrameOfMuxJsTransmuxedTs: boolean;
  browserAacLatencyBehavior: BrowserAACLactencyBehavior;
}

export function getBehaviorFromBrowserEnvironment(): BrowserBehavior {
  return {
    /*
      The video decoder in Firefox seems to have problems with the MP4 fragments
      that mux.js creates when transmuxing from MPEG Transport Stream fragments.
      The result of this is that frame 1 is shown where both frame 0 and frame 1
      is expected to be.

      It might be possible to avoid this behavior by rewriting mux.js to produce
      MP4 fragments with different behavior. We know that this is possible,
      since Firefox does not have any problems consuming the MP4 fragments
      produced by the FFmpeg dash muxer during Kelda live CMAF stream encoding.
    */
    hidesFirstFrameOfMuxJsTransmuxedTs: Object.getOwnPropertyDescriptor(HTMLVideoElement.prototype, 'mozFrameDelay') != null,
    browserAacLatencyBehavior,
  };
}

let browserAacLatencyBehavior : BrowserAACLactencyBehavior = 'unknown';
